import { STORE_KEY } from 'constants/keys';

import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: STORE_KEY,
  storage,
  whitelist: [
    'questionInsights',
    'ptmSlideEvent',
    'talkMeter',
    'ptmFeedback',
    'liveClassConfig',
    'perfectHits',
  ],
};

export { persistConfig };
